import * as types from '../constants/onboarding';

export const createOrganization = (data, token) => ({
  type: types.API_CREATE_ORG,
  data,
  token,
});

export const createOrganizationSuccess = response => ({
  type: types.API_CREATE_ORG_SUCCESS,
  response,
});

export const createOrganizationFailed = response => ({
  type: types.API_CREATE_ORG_FAILED,
  response,
});

export const resetOnboarding = () => ({
  type: types.RESET_ONBOARDING,
});
